import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { ArtikelbezeichnungsgeneratorDto } from '../entities/articles/artikelbezeichnungsgeneratordto.entity';
//#endregion

@Injectable()
export class ArtikelbezeichnungsgeneratorService extends ODataEntityService<ArtikelbezeichnungsgeneratorDto> {
  constructor(protected client: ODataClient) {
    super(client, 'Artikelbezeichnungsgenerator', 'entities.articles.ArtikelbezeichnungsgeneratorDto');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  //#endregion
}
